import { useAppStore } from '../../store/appStore';
import {
  createTaskListScreenModel,
  type TaskListScreenProps,
} from './TaskListScreenModelScreen';
import { TaskListScreenController } from './TaskListScreenController';
import { TaskListScreenView } from './TaskListScreenView';
import { useInfoPopupState } from '../shared/infoPopup/infoPopupState';

export type TaskListScreenContainerProps = Omit<TaskListScreenProps, 'playerEconomy'>;

export type { TaskListScreenProps } from './TaskListScreenModelScreen';

export function TaskListScreen(props: TaskListScreenContainerProps) {
  const playerEconomy = useAppStore((s) => s.playerEconomy);
  const infoPopup = useInfoPopupState();
  const model = createTaskListScreenModel({ ...props, playerEconomy }, infoPopup);
  const controller = new TaskListScreenController(model);

  return <TaskListScreenView model={model} controller={controller} />;
}
